module.exports = __webpack_public_path__ + "f8f60a7f1adc87d30d89a4bd089ee5fb.svg";